import max from 'ml-array-max';
import sum from 'ml-array-sum';

/**
 * Computes the norm of the given values
 * @param {Array<number>} input
 * @param {object} [options={}]
 * @param {string} [options.algorithm='absolute'] absolute, sum or max
 * @return {number}
 */

function norm(input) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$algorithm = options.algorithm,
      algorithm = _options$algorithm === void 0 ? 'absolute' : _options$algorithm;

  if (!Array.isArray(input)) {
    throw new Error('input must be an array');
  }

  if (input.length === 0) {
    throw new Error('input must not be empty');
  }

  switch (algorithm.toLowerCase()) {
    case 'absolute':
      {
        var absoluteSumValue = absoluteSum(input);
        if (absoluteSumValue === 0) return input.slice(0);
        return input.map(function (element) {
          return element / absoluteSumValue;
        });
      }

    case 'max':
      {
        var maxValue = max(input);
        if (maxValue === 0) return input.slice(0);
        return input.map(function (element) {
          return element / maxValue;
        });
      }

    case 'sum':
      {
        var sumValue = sum(input);
        if (sumValue === 0) return input.slice(0);
        return input.map(function (element) {
          return element / sumValue;
        });
      }

    default:
      throw new Error("norm: unknown algorithm: ".concat(algorithm));
  }
}

function absoluteSum(input) {
  var sumValue = 0;

  for (var i = 0; i < input.length; i++) {
    sumValue += Math.abs(input[i]);
  }

  return sumValue;
}

export default norm;
